
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationroundroadtripcabs() {



    const cardData =
    {
        keyword: 'Outstation Round Trip Cabs from Pune',
        heading: 'Platinum24 Cabs: Outstation Round Trip Cabs from Pune',
        headingDescription: ' Platinum24 Cabs provides comfortable Outstation Round Trip Cabs from Pune, making your long-distance journeys safe, reliable, and affordable. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures spacious seating, air-conditioned comfort, and smooth rides for families, groups, and corporate travelers. With professional chauffeurs, punctual pickups, and flexible booking options, we make weekend getaways, pilgrimages, and business tours completely hassle-free. Whether you’re planning a trip to Mumbai, Shirdi, Mahabaleshwar, Lonavala, Goa, or other destinations, Platinum24 Cabs guarantees transparent pricing, 24/7 service, and a dependable round-trip cab experience from Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the grand seat of the Peshwas of the Maratha Empire. Its mighty gates, fountains, and sprawling courtyards narrate tales of Bajirao and Mastani. Although partially destroyed by fire in 1828, the ruins still showcase Maratha pride. The evening light-and-sound show recreates historical glory. History lovers and tourists are drawn to its corridors and gardens. Shaniwar Wada is Pune’s proud symbol of heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it houses a museum displaying Gandhi’s belongings and photographs. Its Italian arches and sprawling gardens add elegance. It is also the memorial site of Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of peace and inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is remembered for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The hilltop fort offers panoramic views of the Sahyadris and trekking trails. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon brings mist and waterfalls, enhancing the experience. Local villagers serve traditional pithla-bhakri at the summit. Sinhagad is Pune’s blend of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, richly decorated with gold, attracts lakhs of devotees. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also renowned for its social and charitable works. The temple’s spiritual aura draws both locals and tourists. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city’s center, it provides peace and spirituality. Evening prayers add a mystical touch. Its ancient rock carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage temple."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure with over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. The recreated Mastani Mahal is a major attraction. Students and history enthusiasts find it highly educational. The museum preserves India’s cultural legacy. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers breathtaking views of the city. The hilltop temple complex is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum enrich its heritage value. Sunsets and sunrises are especially mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho International Meditation Resort in Koregaon Park is a world-renowned center for spirituality and wellness. Spread across lush gardens, it offers meditation, yoga, and therapy programs. Its Zen gardens and modern lifestyle blend attract seekers worldwide. Visitors experience relaxation, rejuvenation, and inner peace. It is Pune’s global destination for mindfulness. Osho Ashram is the city’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features streams, stone bridges, and beautifully manicured lawns. Families enjoy walks, picnics, and photography here. Seasonal flowers and lush greenery make it picturesque year-round. It symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend spot near Pune. It provides water to the city and scenic landscapes for visitors. Monsoon makes it especially beautiful with overflowing streams. Vendors selling hot corn and tea add to the charm. It is also the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


     "services": [
    {
      "name": "Outstation Round Trip Cab Pune",
      "description": "Book reliable and comfortable Outstation Round Trip Cab services from Pune for your long-distance journeys. Perfect for family trips, pilgrimages, business tours, or weekend getaways, our cabs are equipped with all essential amenities to ensure a pleasant and stress-free round trip experience with professional drivers who know the routes well."
    },
    {
      "name": "Round Trip Taxi Pune",
      "description": "Our Round Trip Taxi service in Pune offers you the convenience of traveling to your destination and back in the same cab. Avoid the hassle of multiple bookings or searching for a return ride—our taxis remain at your service for the full journey, ensuring safety, flexibility, and time efficiency."
    },
    {
      "name": "Pune Round Trip Cab Booking",
      "description": "Easily manage your travel plans with our Pune Round Trip Cab Booking service. Available online and through phone, our user-friendly system allows you to book cabs for two-way travel from Pune to any outstation location with assured return rides, transparent pricing, and real-time booking confirmation."
    },
    {
      "name": "Affordable Outstation Round Trip Taxi",
      "description": "Enjoy budget-friendly travel with our Affordable Outstation Round Trip Taxi service from Pune. Our cost-effective packages offer great value, covering fuel, tolls, and driver charges. Whether it’s a family outing or an urgent trip, we deliver quality service at the best prices."
    },
    {
      "name": "Pune Round Trip Taxi Packages",
      "description": "Choose from our wide range of Pune Round Trip Taxi Packages, tailored for popular destinations and travel durations. From one-day return trips to multi-day journeys, our packages are designed for convenience and affordability, with no hidden charges or last-minute surprises."
    },
    {
      "name": "Round Trip Taxi with Driver Pune",
      "description": "Travel in comfort and safety with our Round Trip Taxi with Driver in Pune. Our experienced and courteous chauffeurs handle all the driving while you relax and enjoy your journey. Ideal for stress-free travel with family, friends, or business partners."
    },
    {
      "name": "Pune Round Trip Airport Taxi",
      "description": "Heading to the airport and returning the same day? Our Pune Round Trip Airport Taxi service ensures punctual pickups and drop-offs both ways. Whether for business trips or short vacations, get round-trip airport transfers with professional drivers and clean, air-conditioned vehicles."
    },
    {
      "name": "Outstation Round Trip Car Rental Pune",
      "description": "Get full-day or multi-day Outstation Round Trip Car Rental from Pune with customizable plans. Whether you need a sedan, SUV, or tempo traveller, we have a fleet of well-maintained cars with skilled drivers ready for round-trip journeys across Maharashtra and beyond."
    },
    {
      "name": "Pune Round Trip Taxi Deals",
      "description": "Save more on your next journey with our exclusive Pune Round Trip Taxi Deals. Enjoy discounted fares, combo packages, and seasonal offers on two-way outstation travel. Book early or travel during off-peak times to get the best rates."
    },
    {
      "name": "Round Trip Taxi Service Pune",
      "description": "Our Round Trip Taxi Service in Pune is trusted by thousands of travelers for its punctuality, safety, and top-notch customer experience. Whether it’s a pilgrimage, leisure trip, or corporate visit, we offer door-to-door service with round-trip comfort."
    },
    {
      "name": "Pune Round Trip Taxi Fare",
      "description": "Know your trip cost upfront with our transparent Pune Round Trip Taxi Fare system. No hidden fees—just fixed, all-inclusive prices covering return travel, fuel, and driver allowance. Check fare estimates online or call us for customized quotes."
    },
    {
      "name": "Round Trip Cab Booking Online Pune",
      "description": "Plan your round trip from Pune in just a few clicks with our Online Round Trip Cab Booking platform. Choose your car, set pickup and return times, and get instant confirmation. Our digital service ensures a smooth and convenient booking experience anytime, anywhere."
    },
    {
      "name": "Corporate Round Trip Taxi Pune",
      "description": "Businesses can rely on our Corporate Round Trip Taxi services in Pune for employee transport, client travel, and executive visits. Get clean, chauffeur-driven vehicles with professional billing support, trip tracking, and round-the-clock customer service."
    },
    {
      "name": "Pune Weekend Round Trip Taxi",
      "description": "Explore nearby getaways with our Pune Weekend Round Trip Taxi services. Ideal for short vacations or hill station escapes, our weekend packages include return cab travel, flexible timings, and personalized car options for couples, families, or groups."
    },
    {
      "name": "Pune Outstation Round Trip Cab Service",
      "description": "Book our Pune Outstation Round Trip Cab Service for seamless two-way travel across popular tourist and business destinations. Enjoy doorstep pickup, comfortable rides, and peace of mind with expert drivers and dedicated customer support throughout your journey."
    }
  ],
  "tableData": [
    ["Outstation Round Trip Cab Pune", "Round Trip Taxi Pune"],
    ["Pune Round Trip Cab Booking", "Affordable Outstation Round Trip Taxi"],
    ["Pune Round Trip Taxi Packages", "Round Trip Taxi with Driver Pune"],
    ["Pune Round Trip Airport Taxi", "Outstation Round Trip Car Rental Pune"],
    ["Pune Round Trip Taxi Deals", "Round Trip Taxi Service Pune"],
    ["Pune Round Trip Taxi Fare", "Round Trip Cab Booking Online Pune"],
    ["Corporate Round Trip Taxi Pune", "Pune Weekend Round Trip Taxi"],
    ["Pune Outstation Round Trip Cab Service", "—"]
  ],


          "whychoose": [
    {
      "WhyChooseheading": "Convenient Outstation Round Trip Cabs from Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable round trip taxi services from Pune to all major outstation destinations."
    },
    {
      "WhyChooseheading": "Well-Planned Itineraries for Stress-Free Travel",
      "WhyChoosedescription": "Our round trip packages are designed for a seamless travel experience, ensuring timely pickups and returns."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles for Long Journeys",
      "WhyChoosedescription": "Enjoy sanitized, air-conditioned cabs that are perfect for long-distance travel with family or friends."
    },
    {
      "WhyChooseheading": "Experienced Drivers for Safe and Smooth Rides",
      "WhyChoosedescription": "Our professional drivers are trained and familiar with major outstation routes to ensure your safety."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
      "WhyChoosedescription": "Our round trip fares are all-inclusive, covering fuel, tolls, and driver charges—no surprises later."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Match Your Group Size",
      "WhyChoosedescription": "Choose from sedans, SUVs, and tempo travellers depending on your comfort and luggage needs."
    },
    {
      "WhyChooseheading": "Ideal for Family Vacations, Business Trips & Pilgrimages",
      "WhyChoosedescription": "Perfect for all types of travelers looking for a dependable round trip cab from Pune."
    },
    {
      "WhyChooseheading": "24/7 Booking Support and Travel Assistance",
      "WhyChoosedescription": "Our support team is always available to help you plan, book, or modify your round trip journey."
    }
  ]



























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer outstation round trip cab services from Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable outstation round trip cab services from Pune to various destinations.',
    },
    {
        question: 'How can I book an outstation round trip cab from Pune with Platinum24 Cabs?',
        answer: 'You can book your outstation round trip cab easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for outstation round trips?',
        answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, tempo travellers, and luxury cars to suit different group sizes and travel needs.',
    },
    {
        question: 'Which destinations can I book a round trip cab to from Pune?',
        answer: 'Popular destinations include Mumbai, Mahabaleshwar, Lonavala, Shirdi, Nashik, Goa, Kolhapur, and many more.',
    },
    {
        question: 'Are your drivers experienced with long-distance travel?',
        answer: 'Yes, our drivers are well-trained and experienced in long-distance routes, ensuring a safe and smooth journey.',
    },
    {
        question: 'Is the fare for round trip cabs inclusive of tolls, fuel, and driver charges?',
        answer: 'Yes, the fare includes fuel, driver allowance, tolls, and taxes. Additional charges may apply for extra stops or extended waiting time.',
    },
    {
        question: 'Can I plan a multi-day round trip with a Platinum24 cab?',
        answer: 'Absolutely! We offer flexible multi-day round trip packages based on your travel itinerary.',
    },
    {
        question: 'Are the vehicles sanitized and safe for long-distance travel?',
        answer: 'All our vehicles are regularly sanitized and well-maintained to ensure your safety and comfort during outstation trips.',
    },
    {
        question: 'Can I customize pickup and drop-off points for my round trip?',
        answer: 'Yes, you can choose your preferred pickup and drop-off points in and around Pune and your destination.',
    },
    {
        question: 'Do you provide 24x7 booking for outstation round trip cabs?',
        answer: 'Yes, our booking system is available 24x7, and we can arrange cabs at any time based on your schedule.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Arvind Salvi',
        feedback: 'Booked a round trip cab from Pune to Mahabaleshwar. The service was excellent and hassle-free.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Deepali Patankar',
        feedback: 'Our Pune to Shirdi round trip was well organized. Clean car, experienced driver, and punctual service.',
        rating: 5,
    },
];




























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const outstationRoundTripSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable Outstation Round Trip Cab service from Pune with driver, including airport taxi options, corporate and weekend trip packages.",
  "areaServed": {
    "@type": "Place",
    "name": "Pune"
  },
  "serviceType": [
    "Outstation Round Trip Cab Pune",
    "Round Trip Taxi Pune",
    "Pune Round Trip Cab Booking",
    "Affordable Outstation Round Trip Taxi",
    "Pune Round Trip Taxi Packages",
    "Round Trip Taxi with Driver Pune",
    "Pune Round Trip Airport Taxi",
    "Outstation Round Trip Car Rental Pune",
    "Pune Round Trip Taxi Deals",
    "Round Trip Taxi Service Pune",
    "Pune Round Trip Taxi Fare",
    "Round Trip Cab Booking Online Pune",
    "Corporate Round Trip Taxi Pune",
    "Pune Weekend Round Trip Taxi",
    "Pune Outstation Round Trip Cab Service"
  ],
  "telephone": "+91-XXXXXXXXXX"
};







    return (
        <div>
<Helmet>
  <title>Outstation Round Trip Cabs from Pune | Affordable Round Trip Taxi Pune</title>
  <meta
    name="description"
    content="Affordable and reliable Outstation Round Trip Cab service from Pune with driver, including airport taxi options, corporate and weekend trip packages."
  />
  <meta
    name="keywords"
    content="Outstation Round Trip Cab Pune, Round Trip Taxi Pune, Pune Round Trip Cab Booking, Affordable Outstation Round Trip Taxi, Pune Round Trip Taxi Packages, Round Trip Taxi with Driver Pune, Pune Round Trip Airport Taxi, Outstation Round Trip Car Rental Pune, Pune Round Trip Taxi Deals, Round Trip Taxi Service Pune, Pune Round Trip Taxi Fare, Round Trip Cab Booking Online Pune, Corporate Round Trip Taxi Pune, Pune Weekend Round Trip Taxi, Pune Outstation Round Trip Cab Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(outstationRoundTripSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/68.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Outstationroundroadtripcabs;